import React, { useEffect, useState } from "react";

const Quiz = () => {
  // État pour stocker les questions du quiz
  const [quiz, setQuiz] = useState(null);

  // État pour suivre l'index de la question actuelle
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);

  // État pour suivre le score du joueur
  const [score, setScore] = useState(0);

  // État pour afficher le message de fin du quiz
  const [showEndMessage, setShowEndMessage] = useState(false);

  // Utilisation de useEffect pour initialiser le quiz au chargement du composant
  useEffect(() => {
    // Définition de la classe Question pour représenter une question
    class Question {
      constructor(text, choices, answer) {
        this.text = text;
        this.choices = choices;
        this.answer = answer;
      }

      // Méthode pour vérifier si la réponse donnée est correcte
      isCorrectAnswer(choice) {
        return choice === this.answer;
      }
    }

    // Création des questions du quiz avec leurs réponses
    const questions = [
      new Question(
        "Quelle méthode Javascript permet de filtrer les éléments d'un tableau ?",
        ["indexOf()", "map()", "filter()", "reduce()"],
        "filter()"
      ),
      new Question(
        "Quelle méthode Javascript permet de vérifier si un élément figure dans un tableau ?",
        ["isNaN()", "includes()", "findIndex()", "isOdd()"],
        "includes()"
      ),
      new Question(
        "Quelle méthode transforme du JSON en un objet Javascript ?",
        ["JSON.parse()", "JSON.stringify()", "JSON.object()", "JSON.toJS"],
        "JSON.parse()"
      ),
      new Question(
        "Quel objet Javascript permet d'arrondir à l'entier le plus proche ?",
        ["Math.ceil()", "Math.floor()", "Math.round()", "Math.random()"],
        "Math.round()"
      ),
    ];

    // Initialisation du quiz avec les questions créées
    setQuiz(questions);
  }, []);

  // Fonction pour gérer la réponse donnée par le joueur
  const handleGuess = (choice) => {
    // Récupération de la question actuelle
    const currentQuestion = quiz[currentQuestionIndex];

    // Vérification de l'existence de la question
    if (!currentQuestion) return;

    // Vérification si la réponse est correcte et mise à jour du score
    if (currentQuestion.isCorrectAnswer(choice)) {
      setScore(score + 1);
    }

    // Passage à la question suivante si ce n'est pas la dernière, sinon afficher le message de fin
    if (currentQuestionIndex < quiz.length - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
    } else {
      setShowEndMessage(true);
    }
  };

  // Fonction pour recommencer le quiz
  const handleRestart = () => {
    setCurrentQuestionIndex(0);
    setScore(0);
    setShowEndMessage(false);
  };

  // Récupération de la question actuelle
  const currentQuestion = quiz && quiz[currentQuestionIndex];

  return (
    <div>
      <div className="page-container-quiz">
        <div className="quiz-container">
          <div id="quiz">
            {/* Titre du quiz */}
            <h1>
              <span>Q</span>uiz <i className="far fa-question-circle"></i>
            </h1>

            {/* Affichage de la question actuelle et des choix de réponse */}
            {!showEndMessage && currentQuestion && (
              <>
                <h2>{currentQuestion.text}</h2>

                <div className="choices">
                  {currentQuestion.choices.map((choice, index) => (
                    <button
                      key={index}
                      className="btn hover"
                      onClick={() => handleGuess(choice)}
                    >
                      <p>{choice}</p>
                    </button>
                  ))}
                </div>
              </>
            )}

            {/* Affichage du message de fin du quiz avec le score */}
            {showEndMessage && (
              <>
                <h4>
                  Votre score est de : {score} / {quiz.length}
                </h4>
                <button
                  className="restart-button hover"
                  onClick={handleRestart}
                >
                  {/* Bouton pour recommencer le quiz */}
                  Recommencer
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Quiz;
